/**
 * Product Card Slider
 * Initializes Splide sliders for product cards
 */

document.addEventListener("DOMContentLoaded", function () {
  // Initialize Splide only when the library is loaded
  if (typeof Splide !== "undefined") {
    var sliders = document.querySelectorAll(".product-card-slider");

    sliders.forEach(function (slider) {
      if (slider && !slider.classList.contains("is-initialized")) {
        var splide = new Splide(slider, {
          type: "slider",
          perPage: 1,
          arrows: true,
          pagination: false,
          drag: true,
          autoWidth: false,
          autoHeight: false,
        });

        // Create progress bar segments
        var progressContainer = slider.querySelector(".splide__progress");
        if (progressContainer) {
          splide.on("mounted", function () {
            var slideCount = splide.length;
            progressContainer.innerHTML = ""; // Clear existing content

            // Set CSS variable for slide count
            progressContainer.style.setProperty("--slide-count", slideCount);

            // Create background segments for each slide
            for (var i = 0; i < slideCount; i++) {
              var segment = document.createElement("div");
              segment.className = "splide__progress__segment";
              progressContainer.appendChild(segment);
            }

            // Create the active indicator that will move
            var activeIndicator = document.createElement("div");
            activeIndicator.className = "splide__progress__active";
            progressContainer.appendChild(activeIndicator);

            // Store slide count for calculations
            progressContainer.setAttribute("data-slide-count", slideCount);
          });

          // Update active indicator position on slide change
          splide.on("mounted move", function (i) {
            var activeIndicator = progressContainer.querySelector(
              ".splide__progress__active"
            );
            var slideCount = parseInt(
              progressContainer.getAttribute("data-slide-count")
            );

            if (activeIndicator && slideCount) {
              var position = splide.index * 100;
              activeIndicator.style.transform = "translateX(" + position + "%)";
              if (i === 1) {
                activeIndicator.style.backgroundColor = "var(--gray-03)";
              } else {
                activeIndicator.style.backgroundColor = "var(--gray-02)";
              }
            }
          });
        }

        splide.mount();
        slider.classList.add("is-initialized");

        // Prevent link navigation when clicking arrow buttons or dragging slider
        var mediaLink = slider.closest(".card__media-link");
        if (mediaLink) {
          var isDragging = false;

          splide.on("drag", function () {
            isDragging = true;
          });

          splide.on("dragged", function () {
            setTimeout(function () {
              isDragging = false;
            }, 100);
          });

          // Prevent link navigation when clicking arrow buttons
          var arrowButtons = slider.querySelectorAll(".splide__arrow");
          arrowButtons.forEach(function (button) {
            button.addEventListener("click", function (e) {
              e.preventDefault();
              e.stopPropagation();
            });
          });

          // Prevent link navigation when dragging slider
          mediaLink.addEventListener("click", function (e) {
            if (isDragging) {
              e.preventDefault();
              e.stopPropagation();
            }
          });
        }
      }
    });
  }
});
